import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { orderRoutes } from './order.routes';

export const provideGarageOrderModule: () => Array<
  Provider | EnvironmentProviders
> = () => [
  provideSoftAppsModule(
    {
      name: 'order',
      title: 'Werkstätten Aufträge',
      icon: 'fa-regular fa-garage-car',
      route: '/order',
      permission: 'GARAGEORDER',
      color: 'bg-accent text-white',
      group: getModuleGroupById(11),
    },
    withSoftAppsModuleRoutes({ app: orderRoutes }),
    withSoftAppsModuleTranslation({ de })
  ),
];
